import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  motion,
  AnimatePresence,
  useScroll,
  useTransform,
} from "framer-motion";
import { FaPlaystation, FaXbox, FaSteam, FaGamepad, FaArrowUp, FaCloud, FaArrowRight, FaWindows, FaApple } from "react-icons/fa";
import { DiAndroid } from "react-icons/di";
import { SiNintendoswitch, SiOculus, SiSteamdeck } from "react-icons/si";
import { IoGameController } from "react-icons/io5";
import CardCarousel from "../component/CardCarousel";
import img1 from "../Asset/images/1.webp";
import Loader from "../component/Loader";
import img2 from "../Asset/images/2.webp";
import img3 from "../Asset/images/3.webp";
import LastWinners from "../component/LastWinners/LastWinners";
import Action from "../Asset/images/ch1.webp";
import freeFire from "../Asset/images/free-fire-character-removebg-preview.png";
import ach3 from "../Asset/images/ach3.webp";
import kumfoo from "../Asset/images/kum-foo-removebg-preview.png";
import rac from "../Asset/images/rac.webp";
import sonic from "../Asset/images/sonic-removebg-preview.png";
import br from "../Asset/images/br.webp";
import mario from "../Asset/images/mario-removebg-preview.png";
import sp from "../Asset/images/sp.webp";
import pu from "../Asset/images/pu.webp";
import cl from "../Asset/images/cl.webp";
import ho from "../Asset/images/ho.webp";
import ar from "../Asset/images/ar.webp";
import fi from "../Asset/images/fi.webp";
import fi1 from "../Asset/images/fi2.webp";
import brain from "../Asset/images/brain.webp";
import sar from "../Asset/images/sar.webp";
import rpgs from "../Asset/images/rpgs.webp";
import casino from "../Asset/images/casino.webp";
import cooking from "../Asset/images/cooking.webp";
import party from "../Asset/images/party.webp";
import board from "../Asset/images/board.webp";
import sim from "../Asset/images/Sim.webp";
import fps from '../Asset/images/fps.webp';
import idle from '../Asset/images/Idle-Builder.webp';
import Roguelike from '../Asset/images/Roguelike.webp';
import Diary from '../Asset/images/Diary-Journal.webp';
import rts from '../Asset/images/Strategy-RTS.webp';
import farming from '../Asset/images/Farming.webp';
import platformer from '../Asset/images/Platformer.webp';
import stealth from '../Asset/images/Stealth.webp';
import arcade from '../Asset/images/Arcade.webp';
import utility from '../Asset/images/Utility.webp';
import exploration from '../Asset/images/Exploration.webp';
import educational from '../Asset/images/Educational.webp';
import CommonButton from "../component/CommonButton";
import InfiniteMarqueeCards from "../component/InfiniteMarqueeCards";
import Features from "../component/Features";
import BackgroundColor from "../component/BackgroundColor";
import SubscribeCTA from "../component/SubscribeCTA";
import axiosInstance from "../Utils/axiosInstance";
import consoleImg from "../Asset/images/game-console.png";
import swordImg from "../Asset/images/sword.png";
import { useDispatch, useSelector } from "react-redux";
import SEOHead from "../component/SEOHead";
import { getLatestGamesByCategory, getCloudGames } from "../Redux/Slice/game.slice";
import { fetchBundles } from "../Redux/Slice/bundle.slice";
import { getAllCategoriesWithGameCount } from "../Redux/Slice/category.slice";
import { fetchRecentlyViewed, setRecentlyViewedLocal } from "../Redux/Slice/recentlyViewed.slice";
import AnimatedSparkle from "../component/AnimatedSparkle";
import { IoGameControllerOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import DiscountBanner from "../component/DiscountBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";

const games = [
  { name: "Cyber Hunt", icon: <FaPlaystation size={50} /> },
  { name: "Zombie Arena", icon: <FaXbox size={50} /> },
  { name: "Steam Rush", icon: <FaSteam size={50} /> },
  { name: "Retro Battle", icon: <FaGamepad size={50} /> },
];

export default function HomePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentCharacter, setCurrentCharacter] = useState(0);
  const gamesData = useSelector((state) => state.game.LatestGamesByCategory);
  const cloudGames = useSelector((state) => state.game.cloudGames);
  const categories = useSelector((state) => state.category.categoriesWithCount);
  const { getLatestGamesByCategory: loader1, new10Games: loader2, getCloudGames: loaderCloud } = useSelector((state) => state.game.loadingStates);
  // console.log(gamesData, 'gamesData');

  const { getAllCategories: loader3 } = useSelector((state) => state.category.loadingStates);
  const [tick, setTick] = useState(0);
  const [activeWinnerName, setActiveWinnerName] = useState(gamesData[0]);
  const [dots, setDots] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const recentlyViewedFromRedux = useSelector((state) => state.recentlyViewed?.items || []);
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  const { bundles: activeBundles } = useSelector((state) => state.bundle);
  const userId = localStorage.getItem("yoyouserId");

  useEffect(() => {
    dispatch(fetchBundles());
  }, [dispatch]);

  useEffect(() => {
    if (userId) {
      dispatch(fetchRecentlyViewed());
    } else {
      try {
        const list = JSON.parse(localStorage.getItem("yoyo_recently_viewed") || "[]");
        dispatch(setRecentlyViewedLocal(list));
      } catch (e) {
        dispatch(setRecentlyViewedLocal([]));
      }
    }
  }, [dispatch, userId]);

  useEffect(() => {
    setRecentlyViewed(recentlyViewedFromRedux);
  }, [recentlyViewedFromRedux]);

  const [minLoaderDisplay, setMinLoaderDisplay] = useState(false);

  useEffect(() => {
    if (gamesData.length === 0) {
      dispatch(getLatestGamesByCategory());
    }
    if (!categories || categories.length === 0) {
      dispatch(getAllCategoriesWithGameCount());
    }
  }, [gamesData.length, categories]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      const cloudCat = categories.find(c => c.categoryName.toLowerCase() === 'cloud' || c.categoryName.toLowerCase().includes('cloud'));
      if (cloudCat) {
        dispatch(getCloudGames({ category: cloudCat._id, limit: 25 }));
      }
    }
  }, [categories]);

  useEffect(() => {
    document.title = `Home • YOYO`;
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (pageLoading) {

      const scrollY = window.scrollY;

      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {

      const scrollY = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';


      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
    return () => {

      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [pageLoading]);

  useEffect(() => {
    let timer;
    if (loader1 || loader3 || loaderCloud) {
      setMinLoaderDisplay(true);
    } else {
      timer = setTimeout(() => {
        setMinLoaderDisplay(false);
      }, 2000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [loader1, loader3, loaderCloud]);

  // Update pageLoading based on Redux loading states
  useEffect(() => {
    if (!loader1 && !loader3 && !loaderCloud && !minLoaderDisplay) {
      setPageLoading(false);
    } else {
      setPageLoading(true);
    }
  }, [loader1, loader3, loaderCloud, minLoaderDisplay]);

  const winners = useMemo(() => {
    if (!Array.isArray(gamesData)) return [];
    // console.log('Processing gamesData for winners:', gamesData);

    return gamesData.map((game, idx) => {
      // console.log(`Game ${idx}:`, game);
      // console.log(`Game ${idx} category:`, game.category);

      return {
        id: game._id,
        name: game.title,
        amount:
          game.platforms?.windows?.price ||
          game.platforms?.android?.price ||
          game.platforms?.ios?.price ||
          game.platforms?.nintendo?.price ||
          game.platforms?.quest?.price ||
          game.platforms?.playstation?.price ||
          game.platforms?.xbox?.price ||
          game.platforms?.visionpro?.price ||
          game.platforms?.steamdeck?.price ||
          0, // or any logic for amount
        avatar:
          game.cover_image?.url ||
          "https://api.dicebear.com/8.x/adventurer/svg?seed=lucas",
        category: game.category || "",
        description: game.description || "",
      };
    });
  }, [gamesData]);

  // Scroll-linked floating elements around the categories section
  const floatSectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: floatSectionRef,
    offset: ["start end", "end start"],
  });
  const { scrollY } = useScroll();

  const [swordTravel, setSwordTravel] = useState(1000);
  const [swordHorizontal, setSwordHorizontal] = useState(1000);

  useEffect(() => {
    if (gamesData) {
      setActiveWinnerName(gamesData[0]);
    }
  }, [gamesData]);

  useEffect(() => {
    function updateSwordTravel() {
      if (floatSectionRef.current) {
        const rect = floatSectionRef.current.getBoundingClientRect();
        setSwordTravel(
          rect.height > 0 ? rect.height * 1.18 : window.innerHeight
        );
        setSwordHorizontal(rect.width > 0 ? rect.width : window.innerHeight)
      } else {
        setSwordTravel(window.innerHeight);
        setSwordHorizontal(window.innerWidth);
      }
    }
    updateSwordTravel();
    window.addEventListener("resize", updateSwordTravel);
    return () => window.removeEventListener("resize", updateSwordTravel);
  }, []);

  const leftY = useTransform(scrollYProgress, [0, 1], [0, 1500], {
    clamp: false,
  });
  const rightY = useTransform(scrollYProgress, [0, 1], [0, swordTravel], {
    clamp: false,
  });

  const swordX = useTransform(
    scrollY,
    [0, 500, swordHorizontal],
    [0, 0, -swordHorizontal + 200]
  );

  // Start slightly tilted, end straight
  const leftRotate = useTransform(scrollYProgress, [0, 1], [800, 0]);
  const rightRotate = useTransform(scrollYProgress, [0, 1], [800, 0]);

  // Array of different characters that will rotate
  const characters = [
    {
      name: "Action",
      image: Action,
      description: "Master of flames",
    },
    {
      name: "Adventure",
      image: ach3,
      description: "Frozen spells expert",
    },
    {
      name: "Racing",
      image: rac,
      description: "Forest protector",
    },
    {
      name: "Battle Royale",
      image: br,
      description: "Storm wielder",
    },
    {
      name: "Sports",
      image: sp,
      description: "Darkness master",
    },
    {
      name: "Puzzle Game",
      image: pu,
      description: "Mind master",
    },
    {
      name: "Clicker / Idle",
      image: cl,
      description: "Time master",
    },
    {
      name: "Horror",
      image: ho,
      description: "Fear master",
    },
    {
      name: "Arcade",
      image: ar,
      description: "Classic master",
    },
    {
      name: "Fighting",
      image: fi,
      description: "Combat master",
    },
    {
      name: "Brain Training",
      image: brain,
      description: "Intelligence master",
    },
    {
      name: "Survival",
      image: sar,
      description: "Endurance master",
    },
    {
      name: "Role-Playing Games (RPGs)",
      image: rpgs,
      description: "Story master",
    },
    {
      name: "Casino",
      image: casino,
      description: "Luck master",
    },
    {
      name: "Cooking",
      image: cooking,
      description: "Culinary master",
    },
    {
      name: "Party",
      image: party,
      description: "Social master",
    },
    {
      name: "Board Games",
      image: board,
      description: "Strategy master",
    },
    {
      name: "Simulation",
      image: sim,
      description: "Realism master",
    },
    {
      name: "First Person Shooter",
      image: fps,
      description: "Precision master",
    },
    {
      name: "Idle Builder",
      image: idle,
      description: "Patience master",
    },
    {
      name: "Roguelike",
      image: Roguelike,
      description: "Challenge master",
    },
    {
      name: "Diary / Journal",
      image: Diary,
      description: "Reflection master",
    },
    {
      name: "Strategy / RTS",
      image: rts,
      description: "Tactics master",
    },
    {
      name: "Farming",
      image: farming,
      description: "Growth master",
    },
    {
      name: "Platformer",
      image: platformer,
      description: "Agility master",
    },
    {
      name: "Stealth",
      image: stealth,
      description: "Shadow master",
    },
    {
      name: "Utility",
      image: utility,
      description: "Tool master",
    },
    {
      name: "Exploration",
      image: exploration,
      description: "Discovery master",
    },
    {
      name: "Educational ",
      image: educational,
      description: "Discovery master",
    },
  ];

  // Function to find character by category name
  const findCharacterByCategory = (categoryName) => {
    if (!categoryName) return characters[0]; // Default to first character

    // console.log('Looking for category:', categoryName);

    // Try exact match first
    let character = characters.find(char =>
      char.name.toLowerCase() === categoryName.toLowerCase()
    );

    // If no exact match, try partial match
    if (!character) {
      character = characters.find(char =>
        categoryName.toLowerCase().includes(char.name.toLowerCase()) ||
        char.name.toLowerCase().includes(categoryName.toLowerCase())
      );
    }

    // If still no match, try some common variations
    if (!character) {
      const categoryLower = categoryName.toLowerCase();
      if (categoryLower.includes('rpg') || categoryLower.includes('role')) {
        character = characters.find(char => char.name.includes('RPG'));
      } else if (categoryLower.includes('fps') || categoryLower.includes('shooter')) {
        character = characters.find(char => char.name.includes('First Person'));
      } else if (categoryLower.includes('strategy') || categoryLower.includes('rts')) {
        character = characters.find(char => char.name.includes('Strategy'));
      } else if (categoryLower.includes('puzzle')) {
        character = characters.find(char => char.name.includes('Puzzle'));
      } else if (categoryLower.includes('idle') || categoryLower.includes('clicker')) {
        character = characters.find(char => char.name.includes('Clicker'));
      }
    }
    // console.log('Found character:', character);
    return character || characters[0]; // Fallback to first character
  };

  // Update current character based on active game's category
  useEffect(() => {
    if (activeWinnerName?.category) {
      // console.log('Active game category object:', activeWinnerName.category);

      // Handle different possible category data structures
      let categoryName = null;

      if (typeof activeWinnerName.category === 'string') {
        categoryName = activeWinnerName.category;
      } else if (activeWinnerName.category?.categoryName) {
        categoryName = activeWinnerName.category.categoryName;
      } else if (activeWinnerName.category?.name) {
        categoryName = activeWinnerName.category.name;
      }

      // console.log('Extracted category name:', categoryName);

      if (categoryName) {
        const matchingCharacter = findCharacterByCategory(categoryName);
        const characterIndex = characters.findIndex(char => char.name === matchingCharacter.name);
        if (characterIndex !== -1) {
          // console.log('Setting character to index:', characterIndex);
          setCurrentCharacter(characterIndex);
        }
      }
    }
  }, [activeWinnerName?.category, characters]);

  // Change character and advance synced tick every 2 seconds (only when no specific category is active)
  useEffect(() => {
    // Only auto-rotate if no specific game is selected or if we want to keep the rotation
    const id = setInterval(() => {
      setTick((prev) => prev + 1);
      // Only auto-rotate if no specific category is active
      if (!activeWinnerName?.category) {
        setCurrentCharacter((prev) => (prev + 1) % characters.length);
      }
    }, 2000);

    return () => clearInterval(id);
  }, [characters.length, activeWinnerName?.category]);

  const currentChar = characters[currentCharacter];
  const images = [
    { src: img1, alt: "Image 1" },
    { src: img2, alt: "Image 2" },
    { src: img3, alt: "Image 3" },
    // { src: img1, alt: "Image 4" },
  ];



  useEffect(() => {
    const generateDots = () => {
      const newDots = [];
      const gridSize = 100;
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;

      // Get all grid line positions (vertical and horizontal)
      const verticalLines = [];
      const horizontalLines = [];

      for (let x = gridSize; x <= containerWidth; x += gridSize) {
        verticalLines.push(x);
      }

      for (let y = gridSize; y <= containerHeight; y += gridSize) {
        horizontalLines.push(y);
      }

      // Create vertical dropping dots along grid lines only - ALL THIN SHORT
      verticalLines.forEach((x, index) => {
        if (Math.random() < 1) {
          newDots.push({
            id: `grid-drop-${index}`,
            x,
            startY: -20,
            endY: containerHeight + 20,
            delay: Math.random() * 4,
            duration: 2 + Math.random() * 2,
            widthClass: "w-0.5",
            heightClass: "h-5",
          });
        }
      });

      // Add some horizontal dropping dots along horizontal grid lines - ALL THIN SHORT
      horizontalLines.forEach((y, index) => {
        if (Math.random() < 0.7) {
          const randomX =
            verticalLines[Math.floor(Math.random() * verticalLines.length)];
          newDots.push({
            id: `horizontal-drop-${index}`,
            x: randomX,
            startY: -20,
            endY: containerHeight + 20,
            delay: Math.random() * 6,
            duration: 1.5 + Math.random() * 2.5,
            widthClass: "w-0.5",
            heightClass: "h-4",
          });
        }
      });

      setDots(newDots);
    };

    generateDots();

    const handleResize = () => {
      generateDots();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "Store",
    "name": "Yoyo Game",
    "url": "https://yoyokhel.com",
    "description": "Download and play top games on Windows, Android, iOS, PlayStation, Xbox, Nintendo Switch, Meta Quest, Steam Deck, and Apple Vision Pro.",
    "image": "https://yoyokhel.com/logo556.png",
    "priceRange": "Free – $$$",
    "servesCuisine": "Games",
  };

  return (
    <>
      <SEOHead
        title="Download & Play Games on PC, Mobile, Console & VR"
        description="Yoyo Game is your ultimate gaming store. Browse and download top games for Windows, Android, iOS, PlayStation, Xbox, Nintendo Switch, Meta Quest, Steam Deck, and Apple Vision Pro."
        keywords="download games, buy games, PC games, mobile games, PlayStation games, Xbox games, Nintendo Switch, Android games, iOS games, VR games, Meta Quest, Steam Deck, game store"
        url="https://yoyokhel.com/"
        jsonLd={homeJsonLd}
      />
      {(loader1 || loader3 || loaderCloud || minLoaderDisplay) && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90">
          {/* <DotLottieReact
            className="z-50"
            src={Loader}
            loop
            autoplay
          /> */}
          <Loader />
        </div>
      )}
      <BackgroundColor className="overflow-hidden">
        <div
          className="relative h-screen overflow-hidden "
        //    style={{
        //     background: "linear-gradient(0deg,rgba(15, 13, 18,1) 0%, rgba(15, 13, 18,0) 10%)",
        //   }}
        >
          <AnimatedSparkle
            size={60}
            className="absolute bottom-10 left-5  text-secondary"
            animation="rotate-cw"
          />

          <AnimatedSparkle
            size={40}
            className="absolute bottom-10 right-16 text-primary"
            animation="rotate-ccw"
          />

          <AnimatedSparkle
            size={window.innerWidth <= 1023 ? 40 : 80}
            className="absolute top-16 right-12 md:top-[85px] lg:top-32 md:right-24 opacity-50 text-primary"
            animation="scale"
          />
          <AnimatedSparkle
            size={window.innerWidth <= 1023 ? 20 : 30}
            className="absolute top-24 right-11 md:top-28 lg:top-48 md:right-[89px] lg:right-20 opacity-50 text-secondary"
            animation="scale"
          />

          <IoGameControllerOutline
            size={window.innerWidth <= 1023 ? 40 : 60}
            className="text-primary/90  animate-pulse absolute top-[60%] left-[16%] md:top-[64%] md:left-[51%] lg:top-1/4 lg:left-1/4 -translate-x-1/2 z-20"
          />

          <motion.div
            className="absolute hidden md:block md:left-16 md:top-12 lg:left-16 lg:top-20 z-20"
            animate={{ y: [0, 20, 0] }}
            transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
          >
            <svg
              viewBox="0 0 48 48"
              className={`w-20 md:w-12 lg:w-20 h-20 drop-shadow-lg`}
              fill="none"
            >
              <polygon
                points="28,4 20,26 26,26 20,44 40,18 32,18 38,4"
                fill="#FFF0A37F"
                stroke="#FACC14B2"
                strokeWidth="1"
              />
            </svg>
          </motion.div>

          <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
            {/* Grid Pattern */}
            <div
              className="absolute inset-0 opacity-10"
              style={{
                backgroundImage:
                  "linear-gradient(rgba(255, 255, 255, 0.4) 2px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.4) 2px, transparent 1px)",
                backgroundSize: "100px 100px",
              }}
            />

            <div className="hidden md:hidden sm:hidden xs:hidden lg:block absolute inset-y-0 left-1/2 transform -translate-x-1/2  h-full z-50">
              <img
                src={require("../Asset/images/bg-1.b4a39a49.png")}
                alt="Decorative background"
                className="w-full"
              />
              {/* <img src={require('../Asset/images/Rectangle 2.png')} alt="Decorative background" /> */}
            </div>
            <div className="w-full hidden lg:hidden sm:block xs:hidden md:block absolute inset-y-0 sm:top-[18%] h left-1/2 transform -translate-x-1/2  h-[40%] z-50">
              <img
                src={require("../Asset/images/bg-rotate90.png")}
                alt="Decorative background"
                className="w-full h-full"
              />
            </div>

            {/* Dropping Animated Dots */}
            {dots.map((dot) => {
              // Randomly choose between primary and secondary color for each dot
              const colorClass =
                Math.random() < 0.5 ? "bg-gradient-drop" : "bg-gradient-drop";
              return (
                <div
                  key={dot.id}
                  className={`absolute  ${colorClass} rounded-full shadow-lg`}
                  style={{
                    left: `${dot.x}px`,
                    top: `${dot.startY}px`,
                    width: "0.5px",
                    height: "30px",
                    animation: `dropDown ${dot.duration}s infinite ${dot.delay}s linear`,
                  }}
                />
              );
            })}
          </div>

          {/* Foreground Content */}
          <div className="relative z-10">
            <div className="container">
              {/* <div className="max-w-[80%] mx-auto"> */}
              {/* Main Container */}
              <div className="flex flex-col lg:flex-row gap-8 h-screen items-center lg:items-center lg:justify-between w-full">
                {/* Left Side - Game Name */}
                <div className="order-2 lg:order-1 flex flex-col items-center text-center lg:text-left lg:items-start justify-center space-y-6 p-6 w-full lg:w-1/3">
                  <motion.div
                    initial={{ opacity: 0, x: -16 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.5, delay: 0.1 }}
                  >
                    <div className="relative flex items-center justify-center lg:justify-start gap-3 mb-4 transform text-white/70">
                      <h3 className="text-xl lg:text-lg font-extrabold tracking-wide  text-center">
                        Explore
                      </h3>
                      <span className="inline-block h-2 w-2 rounded-full bg-white/70 " />
                      <h3 className="text-xl lg:text-lg font-extrabold tracking-wide  text-center">
                        Buy
                      </h3>
                      <span className="inline-block h-2 w-2 rounded-full bg-white/70 " />
                      <h3 className="text-xl lg:text-lg font-extrabold tracking-wide  text-center">
                        Enjoy
                      </h3>
                    </div>
                    {/* {activeWinnerName?.category && (
                      <div className="text-xs text-primary/80 mb-2">
                        Category: {typeof activeWinnerName.category === 'string' ? activeWinnerName.category : (activeWinnerName.category?.categoryName || activeWinnerName.category?.name || 'Unknown')}
                      </div>
                    )} */}
                    <h1 className="text-2xl md:text-3xl xl:text-4xl 2xl:text-5xl font-bold gradient-text pb-4">
                      {activeWinnerName?.name?.replace(/"/g, '') || activeWinnerName?.title?.replace(/"/g, '')}
                    </h1>
                    <p className="text-sm text-primary-light/60">
                      {activeWinnerName?.description?.replace(/"/g, '') || currentChar?.description}
                    </p>
                  </motion.div>
                </div>

                {/* Center - Character Display */}
                <div className="order-1 h-[50%] lg:order-2 flex justify-center items-center lg:self-end lg:flex w-full lg:w-1/3 mt-[100px] lg:mt-0">
                  <div className="relative w-full max-w-[280px] sm:max-w-[290px] md:max-w-[330px] lg:max-w-[480px] xl:max-w-[520px] aspect-square flex items-end justify-center">
                    {/* Glowing/rotating background behind character only */}

                    {/* Character with animated transitions on change */}
                    <AnimatePresence mode="wait" initial={false}>
                      <motion.div
                        key={currentCharacter}
                        initial={{
                          opacity: 0,
                          scale: 0.9,
                          y: 20,
                          filter: "blur(6px)",
                        }}
                        animate={{
                          opacity: 1,
                          scale: 1,
                          y: 0,
                          filter: "blur(0px)",
                        }}
                        exit={{
                          opacity: 0,
                          scale: 1.05,
                          y: -20,
                          filter: "blur(6px)",
                        }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                        className="relative z-10"
                      >
                        <div
                          aria-hidden
                          className="pointer-events-none absolute inset-0 flex items-center justify-center"
                        >
                          {/* Soft gradient blobs to create an hourglass-esque glow */}
                          <div
                            className="absolute w-[88%] h-[88%] rounded-full opacity-50 blur-2xl"
                            style={{
                              background:
                                "radial-gradient(circle at 50% 20%, rgba(251,191,36,0.35), transparent 60%), radial-gradient(circle at 50% 80%, rgba(236,72,153,0.25), transparent 60%)",
                            }}
                          />
                          {/* Rotating conic highlight ring */}
                          <div
                            className="absolute w-[88%] aspect-square rounded-full"
                            style={{
                              background:
                                "conic-gradient(from 0deg, rgba(251,191,36,0.25), transparent 30%, rgba(251,191,36,0.25) 60%, transparent 85%, rgba(251,191,36,0.25) 100%)",
                              boxShadow:
                                "0 0 30px rgba(251,191,36,0.25), inset 0 0 50px rgba(251,191,36,0.15)",
                              animation: "spinSlow 24s linear infinite",
                              filter: "blur(1px)",
                            }}
                          />
                        </div>
                        <motion.div
                          animate={{ y: [0, -10, 0] }}
                          transition={{
                            duration: 4,
                            repeat: Infinity,
                            ease: "easeInOut",
                          }}
                          className="flex items-center justify-center"
                        >
                          {currentChar.image ? (
                            <img
                              src={currentChar.image}
                              alt={currentChar.name}
                              className="w-[80%] lg:w-full lg:h-full object-contain drop-shadow-[0_10px_25px_rgba(0,0,0,0.35)]"
                            />
                          ) : (
                            <FaGamepad
                              size={120}
                              className={`animate-pulse ${currentChar.color}`}
                            />
                          )}
                        </motion.div>
                      </motion.div>
                      {/* Character name label */}
                      {/* <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-center">
                        <div className="text-xs text-primary/80 font-medium bg-black/20 px-2 py-1 rounded-full backdrop-blur-sm">
                          {currentChar.name}
                        </div>
                      </div> */}
                    </AnimatePresence>
                  </div>
                </div>

                {/* Right Side - Game Cards and Last Winners */}
                <div className="order-3 hidden lg:flex flex-col justify-center space-y-6 p-6 w-full lg:w-1/3">
                  <motion.div
                    initial={{ opacity: 0, x: 16 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.5, delay: 0.15 }}
                  >
                    <LastWinners
                      tick={tick}
                      onActiveChange={setActiveWinnerName}
                      winners={winners}
                    />
                  </motion.div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
        <div ref={floatSectionRef} className="relative">
          <motion.img
            src={consoleImg}
            alt="console"
            className="absolute -top-6 left-8 w-24 md:w-32 opacity-90 select-none pointer-events-none"
            loading="lazy"
            style={{ y: leftY, rotate: leftRotate }}
          />

          <motion.img
            src={swordImg}
            alt="sword"
            className="absolute -top-6 right-8 w-24 md:w-32 opacity-90 select-none pointer-events-none"
            loading="lazy"
            style={{ y: rightY, x: swordX, rotate: rightRotate }}
          />

          <InfiniteMarqueeCards />

          <CardCarousel
            images={images}
            autoplayDelay={1000}
            showPagination={true}
            showNavigation={true}
          />

          <Features />

          <DiscountBanner />

          {/* Recently Viewed - Continue Browsing Section */}
          {recentlyViewed && recentlyViewed.length > 0 && (
            <section className="w-full py-12 relative overflow-hidden">
              <div className="mx-auto w-full max-w-[100%] md:max-w-[90%] xl:max-w-[80%] px-4">
                <div className="flex items-center justify-between mb-8 relative z-10">
                  <div className="flex flex-col items-center md:items-start text-center md:text-left">
                    <div className="flex items-center gap-2 mb-3 px-4 py-1.5 bg-white/5 rounded-full border border-white/10 w-fit backdrop-blur-md hover:bg-white/10 transition-colors">
                      <IoGameController className="text-primary text-xs animate-pulse" />
                      <span className="text-primary-light/90 text-[10px] uppercase font-bold tracking-[0.2em] font-sans">Recently Viewed</span>
                    </div>
                    <h2 className="text-3xl font-bold font-sans tracking-tighter text-white leading-none">
                      <span className="gradient-text">Continue</span>{" "}
                      <span className="text-white">Browsing</span>
                    </h2>
                  </div>
                  <div className="flex gap-2.5">
                    <button className="continue-swiper-prev bg-white/5 hover:bg-purple-500/20 text-white border border-white/10 hover:border-purple-500/40 sm:p-2.5 p-2 rounded-xl transition-all duration-300 cursor-pointer">
                      <FaChevronLeft className="w-3 h-3 md:w-3.5 md:h-3.5" />
                    </button>
                    <button className="continue-swiper-next bg-white/5 hover:bg-purple-500/20 text-white border border-white/10 hover:border-purple-500/40 sm:p-2.5 p-2 rounded-xl transition-all duration-300 cursor-pointer">
                      <FaChevronRight className="w-3 h-3 md:w-3.5 md:h-3.5" />
                    </button>
                  </div>
                </div>

                <div className="relative z-10">
                  <Swiper
                    spaceBetween={24}
                    slidesPerView={1}
                    navigation={{
                      prevEl: ".continue-swiper-prev",
                      nextEl: ".continue-swiper-next",
                    }}
                    breakpoints={{
                      640: {
                        slidesPerView: 2,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1440: {
                        slidesPerView: 5,
                      },
                    }}
                    modules={[Navigation]}
                    className="pb-2"
                  >
                    {recentlyViewed.map((game) => (
                      <SwiperSlide key={game._id} className="h-auto pb-4">
                        <div
                          onClick={() => navigate(`/gamedetails/${game._id}`)}
                          className="group relative bg-[#0f1115] hover:border-primary/50 border border-white/10 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-[0_0_20px_rgba(98,99,237,0.15)] flex flex-col justify-between h-full"
                        >
                          <div>
                            {/* Image */}
                            <div className="relative h-40 overflow-hidden">
                              <img
                                src={game.cover_image?.url}
                                alt={game.title}
                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                loading="lazy"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                            </div>
                            {/* Info */}
                            <div className="p-4">
                              <span className="text-[9px] uppercase font-bold tracking-wider text-purple-400 bg-purple-500/10 px-2 py-0.5 rounded-full mb-2 inline-block">
                                {game.category?.categoryName || "Game"}
                              </span>
                              <h3 className="text-sm font-bold text-white mb-1 group-hover:text-purple-300 transition-colors line-clamp-1">
                                {game.title}
                              </h3>
                              <p className="text-gray-400 text-[11px] leading-relaxed line-clamp-2">
                                {game.description?.replace(/"/g, "")}
                              </p>
                            </div>
                          </div>
                          {/* Platform Icons Footer */}
                          <div className="px-4 pb-4 pt-2 border-t border-white/5 flex justify-between items-center mt-auto">
                            <div className="flex items-center gap-1.5 text-white/55 text-xs">
                              {game.platforms?.windows?.available && <FaWindows className="hover:text-blue-500 transition-colors" title="Windows" />}
                              {game.platforms?.playstation?.available && <FaPlaystation className="hover:text-blue-500 transition-colors" title="PlayStation" />}
                              {game.platforms?.xbox?.available && <FaXbox className="hover:text-green-500 transition-colors" title="Xbox" />}
                              {game.platforms?.nintendo?.available && <SiNintendoswitch className="hover:text-red-500 transition-colors" title="Nintendo Switch" />}
                              {game.platforms?.ios?.available && <FaApple className="hover:text-white transition-colors" title="iOS" />}
                              {game.platforms?.android?.available && <DiAndroid className="hover:text-green-500 transition-colors" title="Android" />}
                              {game.platforms?.quest?.available && <SiOculus className="hover:text-sky-400 transition-colors" title="Quest" />}
                              {game.platforms?.steamdeck?.available && <SiSteamdeck className="hover:text-blue-400 transition-colors" title="Steam Deck" />}
                            </div>
                            <span className="text-xs font-semibold text-purple-300">
                              {(() => {
                                const prices = Object.values(game.platforms || {})
                                  .filter(p => p.available)
                                  .map(p => p.price);
                                const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
                                return minPrice > 0 ? `$${minPrice}` : "Free";
                              })()}
                            </span>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </section>
          )}

          {/* Cloud Games Section */}
          {cloudGames && cloudGames.length > 0 && (
            <section className="w-full py-16 lg:py-24 relative overflow-hidden">
              {/* Background Glow */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 blur-[120px] rounded-full pointer-events-none opacity-30 mix-blend-screen" />

              <div className="mx-auto w-full max-w-[100%] md:max-w-[90%] xl:max-w-[80%] px-4">

                {/* Header */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  className="flex flex-col md:flex-row items-center md:items-end justify-between mb-8 md:mb-12 gap-6 relative z-10"
                >
                  <div className="flex flex-col items-center md:items-start text-center md:text-left">
                    <div className="flex items-center gap-2 mb-3 px-4 py-1.5 bg-white/5 rounded-full border border-white/10 w-fit backdrop-blur-md hover:bg-white/10 transition-colors">
                      <FaCloud className="text-primary text-xs" />
                      <span className="text-primary-light/90 text-[10px] uppercase font-bold tracking-[0.2em] font-sans">Cloud Streaming</span>
                    </div>
                    <h2 className="text-4xl font-bold font-sans tracking-tighter text-white mt-1 leading-none">
                      <span className="gradient-text">Cloud</span>{" "}
                      <span className="text-white">Powered</span>
                    </h2>
                  </div>

                  <button
                    onClick={() => {
                      const cloudCat = categories?.find(c => c.categoryName.toLowerCase() === 'cloud' || c.categoryName.toLowerCase().includes('cloud'));
                      if (cloudCat) {
                        navigate('/games', { state: cloudCat });
                      } else {
                        navigate('/games');
                      }
                    }}
                    className="group hidden md:flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 hover:border-primary/50 text-white transition-all duration-300"
                  >
                    <span className="text-xs font-bold uppercase tracking-widest font-sans">Explore Library</span>
                    <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform text-primary" />
                  </button>
                </motion.div>

                {/* Unique Bento Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 auto-rows-[250px] md:auto-rows-[280px]">
                  {cloudGames.slice(0, 5).map((game, index) => {
                    const isFeatured = index === 0;
                    return (
                      <motion.div
                        key={game._id}
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4, delay: index * 0.05 }}
                        onClick={() => navigate(`/gamedetails/${game._id}`)}
                        className={`
                            group relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#0f1115] cursor-none
                            ${isFeatured ? 'md:col-span-2 md:row-span-2' : 'col-span-1 row-span-1'}
                            hover:border-primary/50 transition-all duration-500 hover:shadow-[0_0_30px_rgba(98,99,237,0.15)]
                          `}
                      >
                        {/* Background Image */}
                        <div className="absolute inset-0 z-0 h-full w-full">
                          <img
                            src={game.cover_image?.url}
                            alt={game.title}
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-70 group-hover:opacity-100"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-[#0f1115] via-[#0f1115]/20 to-transparent" />
                          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1115]/50 via-transparent to-transparent opacity-80" />
                        </div>

                        {/* Hover Overlay Gradient */}
                        <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 mix-blend-overlay" />

                        {/* Content */}
                        <div className="absolute inset-0 z-20 p-6 flex flex-col justify-between">
                          <div className="flex justify-between items-start">
                            <span className="px-3 py-1 rounded-full bg-black/40 backdrop-blur-md border border-white/10 text-[10px] font-bold uppercase tracking-wider text-white/80 font-sans shadow-xl">
                              {game.category?.categoryName || 'Cloud'}
                            </span>
                            {isFeatured && (
                              <div className="w-10 h-10 rounded-full bg-black/40 backdrop-blur-md border border-white/10 flex items-center justify-center animate-pulse shadow-xl">
                                <FaCloud className="text-primary text-sm" />
                              </div>
                            )}
                          </div>

                          <div className="transform transition-transform duration-500 group-hover:-translate-y-1">
                            <h3 className={`font-bold text-white font-sans leading-none mb-3 drop-shadow-lg ${isFeatured ? 'text-4xl lg:text-5xl' : 'text-xl'}`}>
                              {game.title}
                            </h3>
                            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isFeatured ? 'max-h-24 opacity-100' : 'max-h-0 opacity-0 group-hover:max-h-24 group-hover:opacity-100'}`}>
                              <p className="text-gray-300 text-xs md:text-sm line-clamp-2 mb-4 font-sans font-normal opacity-90 leading-relaxed">
                                {game.description || "Experience the next generation of high-fidelity cloud gaming instantly on any device."}
                              </p>
                              <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest font-sans mt-2">
                                <span className="bg-primary text-white w-9 h-9 rounded-full flex items-center justify-center shadow-lg shadow-[#6263ED]/30 transition-transform duration-300 group-hover:translate-x-1">
                                  <FaArrowRight size={12} />
                                </span>
                                <span className="text-white tracking-widest font-extrabold">View Now</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )
                  })}
                </div>

                {/* Mobile View All Button */}
                <div className="flex md:hidden justify-center mt-8">
                  <button
                    onClick={() => {
                      const cloudCat = categories?.find(c => c.categoryName.toLowerCase() === 'cloud' || c.categoryName.toLowerCase().includes('cloud'));
                      if (cloudCat) {
                        navigate('/games', { state: cloudCat });
                      } else {
                        navigate('/games');
                      }
                    }}
                    className="flex items-center gap-2 px-8 py-4 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 text-white transition-all w-full justify-center"
                  >
                    <span className="text-xs font-bold uppercase tracking-widest font-sans">View All Games</span>
                    <FaArrowRight className="text-xs text-primary" />
                  </button>
                </div>

              </div>
            </section>
          )}
          {/* Game Bundles Section */}
          {activeBundles && activeBundles.length > 0 && (
            <section className="w-full py-16 relative overflow-hidden">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-500/10 blur-[100px] rounded-full pointer-events-none opacity-40 mix-blend-screen" />
              <div className="mx-auto w-full max-w-[100%] md:max-w-[90%] xl:max-w-[80%] px-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  className="flex flex-col md:flex-row items-center md:items-end justify-between mb-8 md:mb-12 gap-6 relative z-10"
                >
                  <div className="flex flex-col items-center md:items-start text-center md:text-left">
                    <div className="flex items-center gap-2 mb-3 px-4 py-1.5 bg-white/5 rounded-full border border-white/10 w-fit backdrop-blur-md hover:bg-white/10 transition-colors">
                      <IoGameController className="text-purple-400 text-xs" />
                      <span className="text-purple-300 text-[10px] uppercase font-bold tracking-[0.2em] font-sans">Special Discount</span>
                    </div>
                    <h2 className="text-4xl font-bold font-sans tracking-tighter text-white mt-1 leading-none">
                      <span className="gradient-text">Game</span>{" "}
                      <span className="text-white">Bundles</span>
                    </h2>
                  </div>

                  <button
                    onClick={() => navigate('/bundles')}
                    className="group flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 hover:bg-purple-500/15 border border-white/10 hover:border-purple-500/50 text-white transition-all duration-300"
                  >
                    <span className="text-xs font-bold uppercase tracking-widest font-sans">View More Bundles</span>
                    <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform text-purple-400" />
                  </button>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10">
                  {activeBundles.slice(0, 3).map((bundle) => (
                    <div
                      key={bundle._id}
                      onClick={() => navigate('/bundles')}
                      className="group relative bg-[#181824]/65 border border-white/10 rounded-[2rem] p-5 flex flex-col justify-between hover:border-purple-500/40 hover:shadow-[0_0_30px_rgba(168,85,247,0.15)] transition-all duration-300 backdrop-blur-md cursor-none"
                    >
                      <div>
                        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">{bundle.name}</h3>
                        <p className="text-white/60 text-xs mb-4 line-clamp-2">{bundle.description || "A custom selection of amazing titles."}</p>

                        <div className="grid grid-cols-3 gap-3 mb-2">
                          {bundle.games.slice(0, 3).map((game) => (
                            <div key={game._id} className="text-center">
                              <div className="aspect-[3/4] rounded-xl overflow-hidden border border-white/10">
                                <img
                                  src={game.cover_image?.url || "placeholder.png"}
                                  alt={game.title}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {(() => {
                        const totalOriginalPrice = bundle.games.reduce((sum, game) => {
                          const prices = [];
                          if (game.platforms) {
                            Object.keys(game.platforms).forEach((p) => {
                              if (game.platforms[p]?.available && game.platforms[p]?.price > 0) {
                                prices.push(game.platforms[p].price);
                              }
                            });
                          }
                          const best = prices.length > 0 ? Math.min(...prices) : 0;
                          return sum + best;
                        }, 0);
                        const saving = totalOriginalPrice - bundle.price;
                        const discountPercentage = totalOriginalPrice > bundle.price ? Math.round((saving / totalOriginalPrice) * 100) : 0;

                        return (
                          <div className="mt-4 pt-4 border-t border-white/5 flex items-center justify-between">
                            <div>
                              {totalOriginalPrice > bundle.price && (
                                <div className="flex items-center gap-2 mb-0.5">
                                  <span className="text-white/40 text-[10px] line-through">${totalOriginalPrice.toFixed(2)}</span>
                                  <span className="text-[9px] bg-green-500/15 border border-green-500/20 text-green-400 font-bold px-1 py-0.5 rounded-md">
                                    {discountPercentage}% OFF
                                  </span>
                                </div>
                              )}
                              <span className="text-white/40 text-[10px] block">Special Price</span>
                              <span className="text-xl font-black text-purple-400">${bundle.price.toFixed(2)}</span>
                            </div>
                            <span className="text-xs font-bold uppercase tracking-widest text-purple-300 group-hover:underline">
                              View details
                            </span>
                          </div>
                        );
                      })()}
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          <SubscribeCTA />
        </div>
      </BackgroundColor>
    </>
  );
}
